<template>
  <div class="w-100">
    <div v-if="canDeleteProcess">
      <Button
        v-if="prime"
        type="button"
        icon="pi pi-trash"
        :badge="String(uuids.length)"
        badge-class="p-badge-primary"
        :class="['p-button p-button-danger px-3', selectedRowsClass]"
        @click="confirmDeleteRealisation"
      />
      <b-button
        v-else
        :variant="'outline-danger'"
        class="w-100"
        @click="confirmDeleteRealisation"
      >
        {{ $t('processes.sidebar.process_delete') }}
      </b-button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Button from 'primevue/button'

export default {
  name: 'RealisationDelete',
  components: {
    Button,
  },
  props: {
    uuids: {
      type: Array,
      default: () => [],
    },
    prime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: false,
    }
  },
  computed: {
    ...mapGetters('realisations', ['recordByUuid', 'getSelectedRecord']),
    ...mapGetters('user', ['canDeleteProcess']),
    ...mapGetters('processes', ['getSelectedProcess']),
    ...mapGetters('assets', ['getAssets']),

    selectedRowsClass () {
      return !this.uuids.length && 'p-disabled p-button-secondary p-button-outlined'
    },
    isSteplessProcess () {
      return ['private', 'brussels', 'wallonia', 'takeover'].includes(this.getSelectedProcess?.processType?.value)
    },
    isAssetProcess () {
      return this.getSelectedProcess?.processType?.value && !this.isSteplessProcess
    }
  },
  methods: {
    isRealisation ({ uuid }) {
      const record = this.recordByUuid({ uuid }) || (this.getSelectedRecord?.uuid === uuid && this.getSelectedRecord)
      return record?.processType?.value === 'realisation'
    },
    errorMessage (response) {
      const caseRef = response.record ? response.record.case?.full : ''
      //const chargingpointId = response.location ? `${response.location.code}-${response.location.properties?.id}` : ''

      return this.error
        ? this.$i18n.t('deleteProcessModal.9', { caseRef })
        : this.$i18n.t('deleteProcessModal.10', { caseRef })
    },

    confirmDeleteRealisation () {
      const h = this.$createElement
      const message = this.uuids.length > 1
        ? this.$i18n.t('deleteProcessModal.1')
        : this.$i18n.t('deleteProcessModal.2')

      const titleVNode = h('div', { domProps: { innerHTML: message } })
      const messageVNode = h('div',
        [
        this.$i18n.t('deleteProcessModal.3'),
          h('ul',
            { class: ['mt-2'] },
            [
              h('li', this.uuids.length > 1
                ? this.$i18n.t('deleteProcessModal.4')
                : this.$i18n.t('deleteProcessModal.5'),
              ),
              h('li', this.$i18n.t('deleteProcessModal.6')),
              h('li', this.$i18n.t('deleteProcessModal.7')),
              h('li', this.$i18n.t('deleteProcessModal.8')),
            ],
          ),
        ])

      this.$bvModal.msgBoxConfirm(
        [messageVNode],
        {
          title: [titleVNode],
          okVariant: 'danger',
          okTitle: this.$i18n.t('processes.sidebar.confirm'),
          cancelTitle: this.$i18n.t('cancel'),
          size: 'lg',
        })
        .then(confirmed => {
          if (confirmed) {
            this.handleDeleteRealisation()
          }
        })
    },

    async handleDeleteRealisation() {
      try {
        this.error = false

        await Promise.all(
          this.uuids.map(async uuid => {
            const record = this.recordByUuid({ uuid }) || this.getSelectedRecord || this.getSelectedProcess

            if (record) {
              const token = await this.$auth.getTokenSilently()
              const api = await fetch('/api/process_delete', {
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ record }),
              })

              const response = await api.json()

              if (response.statusCode === 500) {
                this.error = true

                if (this.$route.params.uuid) {
                  this.$store.dispatch('tenant/setToast', { vm: this, message: this.errorMessage(response.data), error: this.error })
                }
                return
              }

              this.$store.dispatch('realisations/deleteRealisation', { data: response.data })
              this.$store.dispatch('processes/setSelectedAsset', { asset: null })
              if (response.data.record) {
                this.$store.dispatch('processes/deleteProcess', { uuid: response.data.record.uuid })

                if (this.getAssets) {
                  this.$store.dispatch('assets/deleteAssetProcess', { record: response.data.record })
                }
              }

               // Disconnect possible linked request
              if (record.requestUuids?.length) {
                this.$store.dispatch('requests/removeConnectionFromRequests', { requestUuids: record.requestUuids })
              }

              if (!this.prime) {
                this.$store.dispatch('tenant/setToast', { vm: this, message: this.errorMessage(response.data), error: this.error })
                if (!this.error) {
                  const name = record.locationId ? 'LocationList': 'ProcessList'
                  const type = this.getSelectedProcess?.processType?.routeType
                  this.$router.replace({
                    name,
                    params: {
                      ...(record.locationId ? { locationId: record.locationId.full } : {}),
                      ...( this.isSteplessProcess ? { type } : {})
                    }
                  })
                }
              } else {
                this.$emit('realisationDeleted', { record })
              }

              return response
            }

            return record
          }),
        )
        .catch(err => console.log('catch', err))

        this.$emit('allRealisationsDeleted')

        if (this.prime) {
          this.$store.dispatch('tenant/setToast', {
            vm: this,
            message: this.$i18n.t('deleteProcessModal.11'),
            error: false,
            delay: 100,
          })
        }
      } catch (e) {
        this.error = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .p-button {
    &.p-button-icon-only {
      width: auto;
    }
    ::v-deep .p-badge {
      color: #D32F2F;
    }
  }
</style>
